
export const ADD_TO_CART = "ADD_TO_CART";

export const INC = "INC";

export const DEC = "DEC";

export const DEL = "DEL"
